import { DataContext } from "../../../helper/HelperOne"
import NavBar from "../../nav_bar/Navbar"
import { useState } from "react"
import LeadChatList from "./LeadChatList"

const LeadChat = () => {
    const [searchUi, setSearchUi] = useState(false)
    const [searchData, setSearchData] = useState(null)
    return (
        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<LeadChatList/>}
                menuId={10}
            />
        </DataContext.Provider>
    )
}

export default LeadChat